module.exports = __webpack_public_path__ + "img/b.252a36f5.png";